<!-- 弹层 -->
<template>
  <div class="service-popup">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head os-font-16-500">
          <div class="popup-title">{{ title }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <slot></slot>
        </div>
        <div v-if="showFooter" class="popup-bottom os-font-16-500" @click="selectConfirm">
          <div class="popup-button">{{ footerText }}</div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
export default {
  name: 'servicePopup',
  props: {
    title: {
      type: String,
      default: '弹窗'
    },
    // 底部按钮点击事件
    showFooter: {
      type: Boolean,
      default: false
    },
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    }
  },
  data() {
    return {
      showPopup: false
    }
  },
  methods: {
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.$nextTick(() => {
        this.showPopup = true
      })
    },
    closePopup() {
      this.restorePageScroll()
      this.$nextTick(() => {
        this.showPopup = false
      })
    },
    selectConfirm() {
      this.$emit('selectConfirm')
      this.closePopup()
    }
  }
}
</script>

<style lang="scss" scoped>
.service-popup {
  overflow: hidden;

  ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  .popup-wrap {
    position: relative;
    max-height: 75vh;
    overflow: hidden;

    .popup-head {
      height: 56px;
      position: relative;

      .popup-title {
        margin: 0 auto;
        height: 56px;
        padding: 25px 0 13px;
        box-sizing: border-box;
        color: #333;
        text-align: center;
      }

      .popup-close {
        position: absolute;
        right: 16px;
        top: 22px;
        display: block;
        width: 24px;
        height: 24px;
        background-image: url('~@/assets/img/common/close-icon.svg');
        background-size: 100% 100%;
      }
    }

    .popup-content {
      overflow-y: auto;
      box-sizing: border-box;
      max-height: calc(75vh - 56px);
    }

    .popup-bottom {
      border-top: 1px solid #f5f5f5;
      height: 77px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      .popup-button {
        color: #fff;
        border-radius: 82px;
        display: flex;
        width: 264px;
        height: 46px;
        justify-content: center;
        align-items: center;
        background-color: #415fff;

        .vivo-dark-mode & {
          background-color: #3a56e6;
        }
      }
    }
  }
}
</style>
